import { useState } from 'react';

export function useDataExport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleExport = async () => {
    setLoading(true);
    setError(null);
    try {
      // TODO: Replace with real API call if available
      // const res = await api.get('/profile/export');
      // const data = res.data;
      const data = {
        nome: 'João da Silva',
        email: 'joao@exemplo.com',
        acordos: [
          { uuid: '1', tipo: 'punchcard', status: 'ACEITO' },
        ],
      };
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'meus-dados.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      setError('Erro ao exportar dados');
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, handleExport };
}
